import { Campaign } from './campaign';

/**
 * the various event names that comes back from the data
 */
export enum SystemEventName {
  emailBounce = 'emailBounce',
  emailClick = 'emailClick',
  emailComplaint = 'emailComplaint',
  emailOpen = 'emailOpen',
  emailSend = 'emailSend',
  emailSendSkip = 'emailSendSkip',
  emailSubscribe = 'emailSubscribe',
  emailUnSubscribe = 'emailUnSubscribe',
  embeddedSend = 'embeddedSend',
  embeddedClick = 'embeddedClick',
  embeddedDismiss = 'embeddedDismiss',
  embeddedReceived = 'embeddedReceived',
  embeddedImpression = 'embeddedImpression',
  hostedUnsubscribeClick = 'hostedUnsubscribeClick',
  inAppClick = 'inAppClick',
  inAppClose = 'inAppClose',
  inAppDelete = 'inAppDelete',
  inAppDelivery = 'inAppDelivery',
  inAppOpen = 'inAppOpen',
  inAppRecall = 'inAppRecall',
  inAppSend = 'inAppSend',
  inAppSendSkip = 'inAppSendSkip',
  inboxMessageImpression = 'inboxMessageImpression',
  inboxSession = 'inboxSession',
  journeyExit = 'journeyExit',
  purchase = 'purchase',
  pushBounce = 'pushBounce',
  pushOpen = 'pushOpen',
  pushSend = 'pushSend',
  pushSendSkip = 'pushSendSkip',
  pushUninstall = 'pushUninstall',
  smsBounce = 'smsBounce',
  smsClick = 'smsClick',
  smsReceived = 'smsReceived',
  smsSend = 'smsSend',
  smsSendSkip = 'smsSendSkip',
  webPushSend = 'webPushSend',
  webPushSendSkip = 'webPushSendSkip',
  whatsAppSeen = 'whatsAppSeen',
  whatsAppSendSkip = 'whatsAppSendSkip',
  whatsAppBounce = 'whatsAppBounce',
  whatsAppReceived = 'whatsAppReceived', // whatsAppReply
  whatsAppClick = 'whatsAppClick',
  whatsAppSend = 'whatsAppSend',
}

/**
 * the two different event types
 */
export type EventType = 'System' | 'Custom';

export type EventName = SystemEventName | string;

export type EventInfo = {
  eventType: EventName;
  createdAt: string;
  eventName?: string;
  emailListIds?: number[];
  messageTypeIds?: number[];
  channelIds?: number[];
  campaign?: Campaign;
  profileUpdatedAt?: string;
  userAgentDevice?: string;
  userAgent?: string;
  messageId?: string;
  esDocumentId?: string;
  workflowId?: number;
  entranceTime?: string;
  exitTime?: string;
  exitReason?: string;
  exitNodeId?: number;
  nodePath?: number[];
};

export type AggregateEventInfo = {
  count: number;
  eventName: EventName;
  eventType: EventType;
};

export type AssociatedEntity = {
  id: number;
  name: string;
};

export type EventLabel = {
  eventType: EventName;
  eventName?: EventName;
};

export const EVENT_LABELS: Record<SystemEventName, string> = {
  [SystemEventName.emailBounce]: 'Email Bounce',
  [SystemEventName.emailClick]: 'Email Click',
  [SystemEventName.emailComplaint]: 'Email Complaint',
  [SystemEventName.emailOpen]: 'Email Open',
  [SystemEventName.emailSend]: 'Email Send',
  [SystemEventName.emailSendSkip]: 'Email Send Skip',
  [SystemEventName.emailSubscribe]: 'Subscribe',
  [SystemEventName.emailUnSubscribe]: 'Unsubscribe',
  [SystemEventName.embeddedSend]: 'Embedded Send',
  [SystemEventName.embeddedClick]: 'Embedded Click',
  [SystemEventName.embeddedDismiss]: 'Embedded Dismiss',
  [SystemEventName.embeddedReceived]: 'Embedded Received',
  [SystemEventName.embeddedImpression]: 'Embedded Impression',
  [SystemEventName.hostedUnsubscribeClick]: 'Hosted Unsubscribe Click',
  [SystemEventName.inAppClick]: 'In-App Click',
  [SystemEventName.inAppClose]: 'In-App Close',
  [SystemEventName.inAppDelete]: 'In-App Delete',
  [SystemEventName.inAppDelivery]: 'In-App Delivery',
  [SystemEventName.inAppOpen]: 'In-App Open',
  [SystemEventName.inAppSend]: 'In-App Send',
  [SystemEventName.inAppSendSkip]: 'In-App Send Skip',
  [SystemEventName.inAppRecall]: 'In-App Recall',
  [SystemEventName.inboxMessageImpression]: 'Inbox Message Impression',
  [SystemEventName.inboxSession]: 'Inbox Session',
  [SystemEventName.journeyExit]: 'Journey Exit',
  [SystemEventName.pushBounce]: 'Push Bounce',
  [SystemEventName.pushOpen]: 'Push Open',
  [SystemEventName.pushSend]: 'Push Send',
  [SystemEventName.pushSendSkip]: 'Push Send Skip',
  [SystemEventName.purchase]: 'Purchase',
  [SystemEventName.pushUninstall]: 'Push Uninstall',
  [SystemEventName.smsBounce]: 'SMS Bounce',
  [SystemEventName.smsClick]: 'SMS Click',
  [SystemEventName.smsReceived]: 'SMS Received',
  [SystemEventName.smsSend]: 'SMS Send',
  [SystemEventName.smsSendSkip]: 'SMS Send Skip',
  [SystemEventName.webPushSend]: 'Web Push Send',
  [SystemEventName.webPushSendSkip]: 'Web Push Send Skip',
  [SystemEventName.whatsAppSeen]: 'WhatsApp Seen',
  [SystemEventName.whatsAppSendSkip]: 'WhatsApp Send Skip',
  [SystemEventName.whatsAppBounce]: 'WhatsApp Bounce',
  [SystemEventName.whatsAppReceived]: 'WhatsApp Received', // whatsAppReply
  [SystemEventName.whatsAppClick]: 'WhatsApp Click',
  [SystemEventName.whatsAppSend]: 'WhatsApp Send',
};

export enum CustomEventName {
  customEvent = 'customEvent',
}

export const CUSTOM_LABELS: Record<CustomEventName, string> = {
  [CustomEventName.customEvent]: 'Custom Event',
};
